import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { mocker } from 'src/app/mocks/mocker';
import { PhcData } from 'src/app/models/interfaces/portfolio-health-check-data';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChannelBrokerService {
  private isEligible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isEligible$ = this.isEligible.asObservable();
  private userGoals: BehaviorSubject<PhcData> = new BehaviorSubject<PhcData>(null);
  public userGoals$ = this.userGoals.asObservable();
  private isFailure = new BehaviorSubject(false);

  async validateUserChannelBroker(): Promise<void> {
    if (mocker.isMocked) {
      return mocker.mockedValidateUserChannelBroker(this.isEligible, this.isFailure);
    }

    try {
      const response = await fetch(environment.PW3_API + '/phc-eligibility', {
        method: 'GET',
        credentials: 'include',
      });
      const isEligible = await response.json();
      this.isEligible.next(isEligible);

      if (isEligible) {
        const response = await fetch(environment.PW3_API + '/phc-data', {
          method: 'GET',
          credentials: 'include',
        });

        const goals = await response.json();
        this.userGoals.next(goals);
      }
    } catch (error) {
      console.error('Error fetching channel broker interventions:', error);
      this.isFailure.next(true);
      this.isEligible.next(false);
      this.isEligible.error(error);
    }
  }

  getisEligible() {
    return this.isEligible.asObservable();
  }

  getFailure(): Observable<boolean> {
    return this.isFailure.asObservable();
  }
}
